export const assistantSize = {
  width: 192,
  height: 192,
};

export const bedrockResultNotFoundReply =
  'The model cannot find sufficient information';

// TODO: refactor as props
// the following flags are for debug purproses
export const enableDebugMode = false;
export const enableDebugControls = false;
export const enableLogging = true;
// display mute button only on hover over assistant
export const showMuteButtonOnHover = false;
export const useAudioZoneBasedContext = true;
export const debugEventId = undefined;
export const debugTagName = undefined;
